import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { PersonAvatar } from '../avatar/Avatars';
import { NameHelper } from '../contact-methods/NameHelper';
import { ILightUser } from '../user/UserState';

export type ICommentAuthor = Partial<Pick<ILightUser, 'pictureUrl' | 'avatar' | 'color' | 'firstName' | 'lastName'>>;

// Delegates to the shared avatar so a comment's author renders their photo, chosen illustration or
// colour, initials, a failed-image placeholder and a loading state identically to every other surface.
export const CommentAvatar: FC<{ author: ICommentAuthor | undefined; size?: number }> = ({ author, size = 48 }) => {
    const nameHelper = useInstance(NameHelper);

    return (
        <PersonAvatar
            size={size}
            identity={{
                photo: author?.pictureUrl,
                avatar: author?.avatar,
                color: author?.color,
                links: undefined,
                photoHasNoAuditedRoute: true
            }}
            name={nameHelper.getName({ firstName: author?.firstName, lastName: author?.lastName })}
        />
    );
};
